import React, { useState } from 'react';
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton';
import MainLayout from '../Layouts/MainLayout';
import Department from './Department';

function DepartmentContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: 'All User Data',
    navSubTitle: 'Welcome to Cotton Slice',
  });
  const [addUserModal, setAddUserModal] = useState(false);
  const handleAddUserModal = (value = false) => {
    setAddUserModal(value);
  };

  const handleNavParams = (obj) => {
    setNavParams({
      ...navParams,
      ...obj,
    });
  };
  return (
    <MainLayout
      navTitle={navParams.navTitle}
      navSubTitle={navParams.navSubTitle}
      navBarRightComp={
        <CustomButton
          sx={{ padding: '12px 15px', ml: (theme) => theme.spacing(2) }}
          color={'buttonPrimary'}
          onClick={() => handleAddUserModal(true)}
        >
          Add User
        </CustomButton>
      }
    >
      <Department
        handleNavParams={handleNavParams}
        addUserModal={addUserModal}
        handleAddUserModal={handleAddUserModal}
      />
    </MainLayout>
  );
}

export default DepartmentContainer;
